var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 302.77,
    height: 60.925,
    viewBox: "0 0 302.77 60.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    style: {
      fill: "none"
    },
    d: "M0 0h302.77v60.925H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#f8686e}.cls-4{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_148",
    "data-name": "Mask Group 148",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-3",
    d: "M49.094 29.78V4.344A4.344 4.344 0 0 0 44.75 0H22.224a32.688 32.688 0 0 0 26.87 29.78",
    transform: "translate(11.831)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-3",
    d: "M31.068 0H4.344A4.343 4.343 0 0 0 0 4.343v52.238a4.343 4.343 0 0 0 4.344 4.343h52.237a4.343 4.343 0 0 0 4.344-4.343V32.8A35.672 35.672 0 0 1 31.068 0m-1.207 37.455h-14.4a1.489 1.489 0 1 1 0-2.977h14.4a1.489 1.489 0 0 1 0 2.977M55.407 51.89a1.765 1.765 0 1 1 1.375-2.084 1.766 1.766 0 0 1-1.375 2.084m0-7.706a1.765 1.765 0 1 1 1.374-2.084 1.766 1.766 0 0 1-1.375 2.084"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-4",
    d: "M115.8 40.26a5.087 5.087 0 0 0-1.27-3.756 14.665 14.665 0 0 0-4.62-2.639q-6.116-2.317-8.8-5.431a10.921 10.921 0 0 1-2.68-7.357 10.319 10.319 0 0 1 3.642-8.25A15.146 15.146 0 0 1 118 11.292a10.958 10.958 0 0 1 4.508 4.453 13.367 13.367 0 0 1 1.577 6.534h-8.18a6.746 6.746 0 0 0-1.215-4.343 4.253 4.253 0 0 0-3.5-1.494 4.386 4.386 0 0 0-3.351 1.272 4.769 4.769 0 0 0-1.2 3.419 4.221 4.221 0 0 0 1.338 3.031 15.449 15.449 0 0 0 4.747 2.806q5.949 2.151 8.642 5.277a11.754 11.754 0 0 1 2.692 7.958 10.5 10.5 0 0 1-3.376 8.292q-3.381 2.988-9.188 2.988a15.819 15.819 0 0 1-7.176-1.62 12.151 12.151 0 0 1-5.066-4.635 13.46 13.46 0 0 1-1.83-7.119h8.238q0 3.519 1.368 5.109t4.465 1.592q4.3 0 4.3-4.551",
    transform: "translate(51.864 5.172)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    className: "cls-4",
    transform: "translate(183.743 15.443)",
    d: "M0 0h8.209v40.653H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-4",
    d: "M140.031 43.919h16.752v6.813h-26.358V45.79l16.585-28.871h-16.752v-6.84h26.217v4.83z",
    transform: "translate(69.343 5.366)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-4",
    d: "M173.175 33.141h-12.789V43.92h15.134v6.811h-23.343V10.078h23.286v6.842h-15.077v9.6h12.789z",
    transform: "translate(81.012 5.365)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    className: "cls-4",
    transform: "translate(266.948 15.443)",
    d: "M0 0h3.186v40.653H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-4",
    d: "M181.914 50.731V10.078h9.579q6.615 0 10.469 4.231t3.966 11.655v8.517q0 7.652-3.9 11.949t-10.932 4.3zm3.186-37.637v34.678h6.171q5.445 0 8.434-3.365t3.069-9.619v-8.516q0-6.254-2.918-9.717t-8.445-3.462z",
    transform: "translate(96.843 5.365)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-4",
    d: "M54.43 10.151 66.773 46l12.4-35.849H83.4V50.9h-3.19V33.239l.282-17.771L68 50.9h-2.458L53.116 15.635l.277 17.493V50.9H50.2V10.151z",
    transform: "translate(26.726 5.404)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-4",
    d: "m90.9 32.315 10.158-22.164h3.665L92.472 35.562V50.9h-3.19V35.562L77.051 10.151H80.8z",
    transform: "translate(41.018 5.404)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-3",
    d: "M0 0h8.209v8.209H0z",
    transform: "translate(183.743 2.334)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5fc04f375ebe9827673e500cc64ec554.svg";
export { ForwardRef as ReactComponent };